import React from 'react';
import { CUSTOM_ATTACHMENTS } from '../../Pqr_enums';
import DefaultAttachmentSection from './DefaultAttachmentSection';
import AttachmentListSection from './AttachmentListSection';

const AttachmentSection = ({ requestType, ...props }) => {
  const attachmentSetupList = CUSTOM_ATTACHMENTS[requestType];

  if (attachmentSetupList) {
    return (
      <AttachmentListSection
        {...props}
        attachmentSetupList={attachmentSetupList}
      />
    );
  }

  return <DefaultAttachmentSection {...props} />;
};

export default AttachmentSection;
